import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Content, Section, TabMenu } from "../../styles/Common";
import { styled } from "styled-components";
import OnePageLayout from "../../components/layout/OnePageLayout";
import PointHistory from "../../components/myPage/PointHistory";
import ExtinctionHistory from "../../components/myPage/ExtinctionHistory";
import {
  returnOptionText,
  returnYYYYMMDD,
} from "../../components/hooks/basicFunc";
import { ReactComponent as IcoDropDown } from "../../styles/images/ico_arrow_drowdown.svg";
import { getToken, returnLoginStatus } from "../../components/hooks/authFunc";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../store/slices/userSlice";
import TopPointBanner from "../../components/main/TopPointBanner";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";

const MyPoint = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const isLogin = returnLoginStatus();
  const [currentTab, clickTab] = useState(0); //0 = 포인트거래내역, 1 = 소멸 예정 포인트
  const [isOpen, setIsOpen] = useState(false);
  const [option, setOption] = useState(0);
  const accessToken = getToken();
  const pointData = useSelector((state) => state.user.myPointHistory);
  const expirationPointData = useSelector(
    (state) => state.user.myExpirationPoint
  );
  const [data, setData] = useState([]);
  const [expirationData, setExpirationData] = useState([]);
  const today = new Date();
  const year = today.getFullYear(); // 년
  const month = today.getMonth(); // 월
  const day = today.getDate(); // 일
  // 일주일 전 구하기
  const weekAgoDay = new Date(year, month, day - 7);
  // 한달 전 구하기
  const monthAgoDay = new Date(year, month - 1, day);
  // 3개월 전 구하기
  const threeMonthAgoDay = new Date(year, month - 3, day);
  // 6개월 전 구하기
  const sixMonthAgoDay = new Date(year, month - 6, day);
  // 일년 전 구하기
  const yearAgoDay = new Date(year - 1, month, day);
  const [type, setType] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [dayStart, setDayStart] = useState(weekAgoDay); //최초진입 시, 현재로부터 일주일전.
  const [dayEnd, setDayEnd] = useState(today); //최초진입 시, 당일.
  const urls = process.env.REACT_APP_BASE_URL;

  const menuArr = [
    {
      name: "포인트 거래 내역",
      content: <PointHistory data={data} />,
    },
    {
      name: "소멸 예정 포인트",
      content: <ExtinctionHistory data={expirationData} />,
    },
  ];
  const getData = () => {
    if (currentTab == 0) {
      const params = {
        page: 1, // (optioinal) Page number, default 1
        pageSize: pageSize, // (optioinal) Max 50
        type: option, // (optioinal) 0 전체, 1 적립, 2 사용,  5 적립취소, 6 사용취소,  (미사용 3 교환, 4 스왑)
        dayStart: returnYYYYMMDD(dayStart), // (optional) YYYY-MM-DD
        dayEnd: returnYYYYMMDD(dayEnd), // (optional) YYYY-MM-DD
      };
      dispatch(userActions.fetchMyPointHistory({ params, accessToken }));
    } else if (currentTab == 1) {
      const params = {
        page: 1, // (optioinal) Page number, default 1
        pageSize: pageSize, // (optioinal) Max 50
        dayStart: returnYYYYMMDD(dayStart), // (optional) YYYY-MM-DD
        dayEnd: returnYYYYMMDD(dayEnd), // (optional) YYYY-MM-DD
      };
      dispatch(userActions.fetchMyExpirationPoint({ params, accessToken }));
    }
  };
  const selectMenuHandler = (index) => {
    // parameter로 현재 선택한 인덱스 값을 전달해야 하며, 이벤트 객체(event)는 쓰지 않는다
    // 해당 함수가 실행되면 현재 선택된 Tab Menu 가 갱신.
    clickTab(index);
  };

  const handleChoiceOption = (e) => {
    setIsOpen(false);
    setOption(e.target.value);
  };

  const settingStartDay = (days) => {
    switch (days) {
      case "week":
        setDayStart(weekAgoDay);
        setDayEnd(today);
        break;
      case "month":
        setDayStart(monthAgoDay);
        setDayEnd(today);
        break;
      case "threeMonth":
        setDayStart(threeMonthAgoDay);
        setDayEnd(today);
        break;
      case "sixMonth":
        setDayStart(sixMonthAgoDay);
        setDayEnd(today);
        break;
      case "year":
        setDayStart(yearAgoDay);
        setDayEnd(today);
        break;
      default:
        setDayStart(today);
    }
  };
  useEffect(() => {
    getData();
  }, [currentTab, option, dayStart, dayEnd]);

  function getNewData(page, url) {
    const params = {
      page: page + 1, // (optioinal) Page number, default 1
      pageSize: pageSize, // (optioinal) Max 50
      type: option, // (optioinal) 0 전체, 1 적립, 2 사용,  5 적립취소, 6 사용취소,  (미사용 3 교환, 4 스왑)
      dayStart: returnYYYYMMDD(dayStart), // (optional) YYYY-MM-DD
      dayEnd: returnYYYYMMDD(dayEnd), // (optional) YYYY-MM-DD
    };
    const options = {
      method: "POST",
      body: JSON.stringify({
        params,
        accessToken: accessToken,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    };
    return fetch(url, options)
      .then((response) => response.json())
      .then((data) => {
        console.log(data.params, currentTab);
        setData((prevData) => [...prevData, data.params]);
      });
  }
  useEffect(() => {
    let page;
    if (
      currentTab == 0 &&
      Object.keys(pointData).length !== 0 &&
      pointData.count != 0
    ) {
      // setData((prevData) => [...prevData, pointData]);
      setData([pointData]);
      page = 1;

      const handleScroll = () => {
        // 현재 스크롤 위치
        const scrollY = window.scrollY || window.pageYOffset;
        const viewportHeight = window.innerHeight;
        const documentHeight = Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight,
          document.body.offsetHeight,
          document.documentElement.offsetHeight,
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
        // 뷰포트의 높이

        // console.log(
        //   documentHeight,
        //   viewportHeight,
        //   scrollY,
        //   viewportHeight + scrollY,
        //   pointData?.count
        // );
        const distanceToBottom = documentHeight - (viewportHeight + scrollY);
        const totalPage = Math.ceil(pointData.count / pageSize);
        //전체수에서 페이지사이즈를 나누면 totalPage
        //현재페이지는 totalPage를 넘으면 안됨.
        if (currentTab == 0 && distanceToBottom <= 0 && totalPage > page) {
          getNewData(page, `${urls}/mu/user/point/history`);
          page++;
        }
      };

      // 스크롤 이벤트 리스너 등록
      window.addEventListener("scroll", handleScroll);

      // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    } else {
      // console.log("xx", pointData);
      setData([]);
    }
  }, [pointData, currentTab]); // useEffect의 두 번째 매개변수로 빈 배열을 전달하여 한 번만 실행되도록 설정

  useEffect(() => {
    let page;
    if (
      currentTab == 1 &&
      Object.keys(expirationPointData).length !== 0 &&
      expirationPointData.count != 0
    ) {
      // console.log("expirationPointData", expirationPointData);
      // setExpirationData((prevData) => [...prevData, expirationPointData]);
      setExpirationData([expirationPointData]);
      page = 1;

      const handleScroll = () => {
        // 현재 스크롤 위치
        const scrollY = window.scrollY || window.pageYOffset;
        const viewportHeight = window.innerHeight;
        const documentHeight = Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight,
          document.body.offsetHeight,
          document.documentElement.offsetHeight,
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
        // 뷰포트의 높이

        // console.log(
        //   documentHeight,
        //   viewportHeight,
        //   scrollY,
        //   viewportHeight + scrollY,
        //   pointData?.count
        // );
        const distanceToBottom = documentHeight - (viewportHeight + scrollY);
        const totalPage = Math.ceil(expirationPointData.count / pageSize);
        //전체수에서 페이지사이즈를 나누면 totalPage
        //현재페이지는 totalPage를 넘으면 안됨.
        // console.log(totalPage, page);
        if (currentTab == 1 && distanceToBottom <= 0 && totalPage > page) {
          // console.log("화면 바닥에 닿았습니다! 목록이 더 있습니다", page);
          getNewData(page, `${urls}/mu/user/point/expiration`);
          page++;
        }
      };

      // 스크롤 이벤트 리스너 등록
      window.addEventListener("scroll", handleScroll);

      // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    } else {
      setExpirationData([]);
    }
  }, [expirationPointData, currentTab]); // useEffect의 두 번째 매개변수로 빈 배열을 전달하여 한 번만 실행되도록 설정

  return (
    <OnlyHeaderLayout title="MY 포인트">
      <Section className="nonePaddingTop">
        <div>
          {isLogin && <TopPointBanner />}
          <Content>
            <div>
              <TabMenu>
                {menuArr.map((el, index) => (
                  <li
                    key={index}
                    className={
                      index === currentTab ? "pointer focused" : "pointer"
                    }
                    onClick={() => selectMenuHandler(index)}
                  >
                    {el.name}
                  </li>
                ))}
              </TabMenu>
              <DatePickerWrap>
                <Period>
                  <li
                    className="pointer"
                    onClick={() => {
                      settingStartDay("week");
                    }}
                  >
                    1주일
                  </li>
                  <li
                    className="pointer"
                    onClick={() => {
                      settingStartDay("month");
                    }}
                  >
                    1개월
                  </li>
                  <li
                    className="pointer"
                    onClick={() => {
                      settingStartDay("threeMonth");
                    }}
                  >
                    3개월
                  </li>
                  <li
                    className="pointer"
                    onClick={() => {
                      settingStartDay("sixMonth");
                    }}
                  >
                    6개월
                  </li>
                  <li
                    className="pointer"
                    onClick={() => {
                      settingStartDay("year");
                    }}
                  >
                    1년
                  </li>
                </Period>
                <Duration>
                  {currentTab == 0 ? (
                    <>
                      <PickDate>
                        <div>
                          {" "}
                          <input
                            className="pointer date-picket-input"
                            type="date"
                            onChange={(e) => {
                              setDayStart(e.target.value);
                            }}
                            value={returnYYYYMMDD(dayStart) || new Date()}
                          />
                        </div>
                        -
                        <div>
                          <input
                            className="pointer date-picket-input"
                            type="date"
                            onChange={(e) => {
                              setDayEnd(e.target.value);
                            }}
                            value={returnYYYYMMDD(dayEnd) || new Date()}
                          />
                        </div>
                      </PickDate>

                      <SelectWrap className="pointer">
                        <SelectValue onClick={() => setIsOpen(!isOpen)}>
                          <div className={isOpen ? "isOpen" : ""}>
                            {returnOptionText(option)}
                            <IcoDropDown />
                          </div>
                        </SelectValue>
                        {isOpen && (
                          <ul>
                            <li onClick={handleChoiceOption} value={0}>
                              전체
                            </li>
                            <li onClick={handleChoiceOption} value={1}>
                              적립
                            </li>
                            <li onClick={handleChoiceOption} value={2}>
                              사용
                            </li>

                            <li onClick={handleChoiceOption} value={5}>
                              적립취소
                            </li>
                            <li onClick={handleChoiceOption} value={6}>
                              사용취소
                            </li>
                          </ul>
                        )}
                      </SelectWrap>
                    </>
                  ) : (
                    <ExtinctionPickDate>
                      <div>
                        {" "}
                        <input
                          className="pointer date-picket-input"
                          type="date"
                          onChange={(e) => {
                            setDayStart(e.target.value);
                          }}
                          value={returnYYYYMMDD(dayStart) || new Date()}
                        />
                      </div>
                      -
                      <div>
                        <input
                          type="date"
                          className="pointer date-picket-input"
                          onChange={(e) => {
                            setDayEnd(e.target.value);
                          }}
                          value={returnYYYYMMDD(dayEnd) || new Date()}
                        />
                      </div>
                    </ExtinctionPickDate>
                  )}
                </Duration>
              </DatePickerWrap>
              <Desc>{menuArr[currentTab].content}</Desc>
            </div>
          </Content>
        </div>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default MyPoint;

const DatePickerWrap = styled.div`
  .date-picket-input {
    text-align: center;
    font-family: NanumSquareR;
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 4rem;
    position: relative;
  }
`;
const Period = styled.ul`
  margin-top: 2rem;
  background-color: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.black};
  display: flex;
  li {
    width: 25%;
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 4rem;
    text-align: center;
    position: relative;
    &::before {
      display: block;
      content: "";
      width: 0.9px;
      height: 2.3rem;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      background-color: #d3d3d3;
    }
    &:nth-of-type(1) {
      &::before {
        display: none;
      }
    }
  }
`;
const Duration = styled.div`
  margin-top: 1rem;
  position: relative;
  display: flex;
  justify-content: space-between;
`;
const PickDate = styled.div`
  width: calc(100% - 9.5rem);
  display: flex;
  justify-content: space-between;
  line-height: 4rem;
  & > div {
    border: 1px solid #000;
    width: calc(50% - 0.5rem);
    height: 4rem;
    text-align: center;
    background-color: ${({ theme }) => theme.color.white};
    font-size: 1.2rem;
    font-weight: 700;
  }
  input {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: transparent;
    font-size: 1.2rem;
    font-weight: 700;
    text-align: center;
    color: ${({ theme }) => theme.color.black};
    &::placeholder {
      text-align: center;
    }
  }
  input[type="date"]::-webkit-calendar-picker-indicator {
    /* 달력 아이콘 이미지를 숨깁니다. */
    position: absolute; // 이를 설정하기 위해 사전에 relative를 설정한 것이다.
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: transparent; // 배경은 투명하게,
    color: transparent; // 글자도 투명하게! 이 두 설정을 통해 캘린더 아이콘을 사라지게 만든다.
    cursor: pointer;
  }
  input::-webkit-date-and-time-value {
    text-align: center;
  }
  input[type="date"]::-webkit-inner-spin-button {
    display: none;
    appearance: none;
  }

  input[type="date"] {
    /* 달력을 열 수 있는 아이콘을 숨깁니다. */
    text-align: center;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    display: flex;
    justify-content: center;
  }
`;
const SelectWrap = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  border: 1px solid #000;
  width: 8.5rem;
  background-color: ${({ theme }) => theme.color.white};

  font-size: 1.2rem;
  text-align: center;
  color: ${({ theme }) => theme.color.black};
  ul {
    width: 100%;
    li {
      height: 4.2rem;
      line-height: 4.2rem;
    }
  }
`;
const SelectValue = styled.div`
  padding: 0 1rem;
  line-height: 4rem;
  height: 3.84rem;
  & > div {
    text-align: center;
    font-weight: 700;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .isOpen {
    border-bottom: 1px dashed #919191;
  }
`;

const ExtinctionPickDate = styled(PickDate)`
  width: 100%;
`;
const Desc = styled.div`
  margin-top: 1.5rem;
`;
